<template>
  <div class="choose">
    <div class="state-head">选择气象站</div>
    <div v-for="item in listData" :key="item.station_id" class="sta-item" @click="go(item.station_id)">
      {{item.station_name}}
    </div>
    <div v-if="listData.length==0" class="sta-empty">暂无数据</div>




  </div>
</template>

<script>

  export default {
  name: 'Choose',
  components: { },
  mounted(){
  },
  data() {
    return{
      listData:[],
      chartData: {}
    }
  },
  created: function () {
    // `this` 指向 vm 实例
    this.getData();
    // let that = this;
    // setInterval(()=>{that.getData()},10000)
  },
  methods: {
    getData(){
      let that = this;
      this.$api.getList()
              .then(res =>{
                console.log(res);
                if(res.status === 200){
                  let data = res.data.data;
                  //处理列表
                  that.listData = data;
                  console.log( data)
                }
              })
              .catch(res =>{
                console.log(res)
              })
    },
    go(id){
      this.$router.push('/display/'+id)
    },
    random(len, min, max , bili=1){
      let arr=[]
      for (var i = 1; i <= 24; i++) {
        arr.push((Math.floor(Math.random() * (max - min)) + min)/bili)
      }
      return arr
    }
  }
}
</script>

<style lang="scss">
.choose {
  .state-head{
    position: relative;
    background: #409EFF;
    font-size: 18px;
    line-height: 50px;
    color: #fff;
    padding-left: 12px;
  }
  .sta-item{
    margin: 15px;
    padding:0 15px;
    border: 1px solid #ccc;
    background: #eee;
    border-radius: 10px;
    line-height: 50px;
  }
  .sta-empty{
    padding: 60px 0;
    text-align: center;
    color: #666;
  }
}

</style>
